export interface LanguageModel {
  label: string;
  value: string;
  flag: string;
  isDefault: boolean;
}

export const Languages: LanguageModel[] = [
  {
    label: 'English',
    value: 'en',
    flag: 'fi fi-gb',
    isDefault: true,
  },
  {
    label: 'Nederlands',
    value: 'nl',
    flag: 'fi fi-nl',
    isDefault: false,
  },
];
